import { useCallback, useState } from 'react'

import { authHeader } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const usePreviewMissingSensorData = () => {
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(null)
  const [data, setData] = useState(null)

  const fetchPreview = useCallback(
    async (sensorID, entityID1, entityID2, timestep) => {
      setLoading(true)
      setError(null)
      try {
        await refreshToken()
        const qs = new URLSearchParams({
          sensor: String(sensorID),
          entity1: String(entityID1),
          entity2: String(entityID2),
          timestep: String(timestep),
        })
        const url = `${REACT_APP_API_URL}/iot/missing-data?${qs}`
        const options = { headers: { ...authHeader() }, method: 'GET' }
        const result = await fetch(url, options)
        if (!result.ok) {
          const text = await result.text()
          throw new Error(text || `HTTP ${result.status}`)
        }
        const payload = await result.json()
        setData(payload)
        return payload
      } catch (error) {
        console.error('fetchPreview error:', error)
        setError(error?.message || 'Fehler beim Laden')
        return null
      } finally {
        setLoading(false)
      }
    },
    []
  )

  const reset = useCallback(() => {
    setData(null)
    setError(null)
    setLoading(false)
  }, [])

  return { fetchPreview, isLoading, isError, data, reset }
}
